import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row, Table, DropdownItem } from 'reactstrap';

import Icon from '@/components/common/icon';
import { Input } from '@/components/form';
import ResourceList from '@/components/resources/list';
import View from '@/components/view';
import { t } from '@/services/translator';

export default () => {
  const redirect = (item) => (
    <>
      <DropdownItem>
        <Link to={`/sheet_actions/view/${item.id}`}>
          <Icon name="pager" className="iconRightMarginMax" /> {t('adminapp_View')}
        </Link>
      </DropdownItem>
    </>
  );

  return (
    <View>
      <ResourceList
        resource="SheetAction"
        deleteMultiple
        filters={() => (
          <Row>
            <Col lg={3}>
              <Input name="name" />
            </Col>
          </Row>
        )}
        body={({ collection, renderColumn, renderItemActions, renderSelect }) => (
          <Table responsive hover>
            <thead className="thead-light">
              <tr>
                {renderColumn(renderSelect('*'), false)}
                {renderColumn('id')}
                {renderColumn('name')}
                {renderColumn()}
              </tr>
            </thead>
            <tbody>
              {collection.map((item) => (
                <tr key={item.id}>
                  <td>{renderSelect(item.id)}</td>
                  <td>{item.id}</td>
                  <td>{item.name}</td>
                  <td>{renderItemActions(item, redirect(item))}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      />
    </View>
  );
};
